import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Indicator.css';

const cx = classnames.bind(styles);

function Indicator({
    className,
    value,
    incValue,
    height
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <div
                className={styles.activeBar}
                style={{width: `${value}%`, height, border: Boolean(incValue) ? '1px solid #323540' : ''}}
            />
            {Boolean(incValue) && (
                <div
                    className={cx('incValueBar', {low: incValue < 6, medium: incValue === 6, high: incValue >= 7})}
                    style={{width: `${Number(value) + incValue}%`, height}}
                />
            )}
        </div>
    );
};

Indicator.propTypes = {
    className: PropTypes.string,
    value: PropTypes.number.isRequired,
    incValue: PropTypes.number,
    height: PropTypes.number
};

Indicator.defaultProps = {
    className: '',
    incValue: 0,
    height: 2
};

export {
    Indicator
}
